<template>
  <div id="main-page">
    <div v-if="!renungan" id="loading">
      <VueLoading
        type="spin"
        color="#ffd169"
        :size="{ width: '100px', height: '100px' }"
      ></VueLoading>
    </div>
    <div v-else class="renungan-container">
      <img v-bind:src="renungan.coverImage" alt="" id="renungan-image" />
      <div class="renungan-title">
        <h1>{{ renungan.title.rendered }}</h1>
        <h2>{{ convertDate(renungan.date) }}</h2>
      </div>
      <div class="renungan-body bg-blue">
        <p class="verse">{{ renungan.verse }}</p>
        <h2 class="ayat">Baca: <span v-html="renungan.passage"></span></h2>
        <div v-html="renungan.content.rendered"></div>
        <p class="response">{{ renungan.response }}</p>
        <p>
          source:
          <a href="https://santapanrohani.org" target="blank"
            >santapanrohani.org</a
          >
        </p>
      </div>
      <h3 class="thought">{{ renungan.thought }}</h3>
    </div>
  </div>
</template>
<script>
import { VueLoading } from "vue-loading-template";
import { mapState } from "vuex";
import { convertDate } from "../utils";

export default {
  name: "Renungan",
  components: {
    VueLoading
  },
  computed: mapState({
    renungan: state => state.renungan.renungan,
    loading: state => state.renungan.loading
  }),
  created() {
    this.$store.dispatch("renungan/getRenungan");
  },
  methods: {
    convertDate
  }
};
</script>

<style scoped>
#loading {
  padding: 50vh 0;
}

#renungan-image {
  width: 100%;
  height: auto;
}

.renungan-container {
  padding-top: 6em;
  text-align: left;
}

.renungan-body {
  padding: 2em 2em 1em 2em;
}

.ayat {
  color: black !important;
}

.renungan-title {
  padding: 0 2em;
}

.verse {
  color: black;
  font-style: italic;
}

.response {
  text-align: center;
  font-style: italic;
}

.thought {
  color: black;
  padding: 1em 3em;
  text-align: center;
}
</style>
